<template>
  <div
    :style="
      locale === 'de'
        ? { '--locale-width': 'min-content' }
        : { '--locale-width': 'max-content' }
    "
    class="flex flex-row justify-start"
  >
    <div
      class="rotated text-qwraysuperlight md:text-8px lg:text-12px xl:text-16px self-end mb-auto mt-2"
    >
      {{ $t(name) }}
    </div>
    <nav
      class="nav-item flex flex-col text-white md:text-8px lg:text-12px xl:text-16px"
    >
      <router-link
        v-for="(link, index) in links"
        v-bind:key="index"
        :to="{ path: link.ref }"
        v-bind:class="index == 0 ? '' : 'mt-2'"
        >{{ $t(link.text) }}
      </router-link>
    </nav>
  </div>
</template>
<script>
import i18n from '@/i18n';

export default {
  data() {
    return {
      locale: i18n.locale,
    };
  },
  props: ['links', 'name'],
};
</script>

<style>
.lastElement {
  --footer-margin-left: 1.25rem;
  --footer-nav-item-margin: 0.5rem;
  margin-left: var(--footer-margin-left);
}
.lastElement > nav {
  width: var(--locale-width, min-content);
}
.nav-item {
  margin-left: 0.5rem;
}

.rotated {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
}
@media (min-width: 1024px) {
  .lastElement {
    --footer-margin-left: 1rem;
  }
  .nav-item {
    margin-left: 0.1rem;
  }
}
@media (min-width: 1280px) {
  .lastElement {
    --footer-margin-left: 1.2rem;
  }
  .nav-item {
    margin-left: 0.5rem;
  }
}
@media (min-width: 1400px) {
  .lastElement {
    --footer-margin-left: 2.5rem;
  }
  .nav-item {
    margin-left: 1rem;
  }
  .lastElement > nav {
    width: auto;
  }
}
</style>
